export const GET_USER_DETAILS_BY_EMAIL_QUERY = `{
  getUserDetailsByEmail(email: "$email") {
    id
    firstName
    lastName
    preferredName
    email
    roleName
    profileImageURL
    coverImageURL
    acceptedTerms
    permissions
    logLevel
  }
}`;
